<template>
  <div>
    <v-snackbar v-model="snackbar" :top=true :color="color" :timeout=6000>
      <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-data-table :headers="headers" :items="service_type_list" sort-by="calories" dense class="elevation-1 mytable"
      :search="search">
      <template v-slot:top>
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Employee Category Details</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-row dense justify="center" class="mt-5">
          <v-col sm="3" md="3" cols="12">
          </v-col>
          <v-col sm="6" md="6" cols="12">
            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
          </v-col>
          <v-col sm="3" md="3" cols="12">

            <span style="width: 20px"> </span>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn small class="mb-2 button" v-on="on">Add Employee Category</v-btn>
              </template>
              <v-card>
                <v-card-title class="toolbar">
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field v-model="editedItem.service_type" persistent-hint 
                          label="Employee Category Name"
                          :error="errorMsg.serviceType?true:false"
                          :error-messages="errorMsg.serviceType?'Required':''">
                        </v-text-field>
                      </v-col>
                       <v-col cols="12">
                        <v-text-field v-model="editedItem.display_name" persistent-hint 
                          label="Display Name"
                          >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" v-if='editedIndex != -1'>
                        <v-checkbox dense v-model="editedItem.isactive" color="success" label="Active"></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn class="button" @click="close">Cancel</v-btn>
                  <v-btn class="button" @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </template>

      <template v-slot:item.isactive="{ item }">
        <span v-if="item.isactive">
          <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
        </span>
        <span v-else>
          <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
        </span>
      </template>
      <template v-slot:item.action="{ item }">
        <div>
        <v-avatar size="25" class="edit-avatar">
            <v-icon  small @click="editItem(item)">
            mdi-pencil
            </v-icon>
        </v-avatar>

        <v-avatar size="25" class="edit-avatar ml-2">
            <v-icon small  @click="deleteItem(item)">
            mdi-delete
            </v-icon>
        </v-avatar>
        </div>
      </template>

    </v-data-table>
  </div>
</template>

<script>
import axios from 'axios'
import "@/assets/css/color.css"; 
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";

export default {
  components: {
    Breadcrumbs,
  },
    data: () => ({
      errorMsg:{
        serviceType:false
      },
      search:'',
      snackbar_msg: "",
      color: "",
      snackbar: false,

      dialog: false,
      headers: [
        {
          text: 'Name',align: 'left',sortable: true,value: 'service_type',
        },
        {
          text: 'Display Name',align: 'left',sortable: true,value: 'display_name',
        },
        {
          text: 'Active',align: 'left',sortable: true,value: 'isactive',
        },
        { 
          text: 'Actions', value: 'action', sortable: false 
        },
      ],
      service_type_list: [],
      editedIndex: -1,
      editedItem: {
        service_type_id : "",
        service_type: "",
        display_name :"",
        isactive:true
      },
      defaultItem: {
        service_type_id : "",
        service_type: "",
        display_name:"",
        isactive:true
      },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Employee Category' : 'Edit Employee Category'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    mounted(){
     this.onLoad();
    },
    methods: {
       initializeErrorMsgFalse(){
      this.errorMsg.serviceType=false;
     
    },
      showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
      editItem (item) {
        this.editedIndex = this.service_type_list.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem(item) {
        if (confirm('Are you sure you want to delete this item?')) {

            const data = {
            id: item.service_type_id
            };

            axios
            .post("/roleManagement/deleteServiceType", data)
            .then(res => {
                if (res.data.code === "SUCCESS") {
                this.showSnackbar(
                  "#4caf50",
                  "Employee Category Deleted Successfully..."
                );
                this.onLoad()
                }
            })
            .catch(error => {
                console.log(error);
            });
        }
    },

      onLoad(){
        axios
        .post("/roleManagement/serviceType")
        .then(res => {
            if (res.data.msg == "200") {
            this.service_type_list = res.data.service_type_list
            this.load = true;
            } else {
            }
        })
        .catch(error => {
            window.console.log(error);
        });
      },
      close () {
        this.initializeErrorMsgFalse();
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (!this.isValidated()) return;
        if (this.editedIndex > -1) {
            axios
            .post("/roleManagement/editServiceType", this.editedItem)
            .then(res => {
                if (res.data.code === "SUCCESS") {
                this.showSnackbar(
                    "#4caf50",
                    "Employee Category Updated Successfully..."
                );
                this.onLoad();
                this.close();
                }else if(res.data.code === "NA"){
                    this.showSnackbar(
                    "#b71c1c",
                    res.data.message || "Employee Category Already Exists"
                );
                }
            })
            .catch(error => {
                console.log(error);
            });

        } else {
            axios
            .post("/roleManagement/saveServiceType", this.editedItem)
            .then(res => {

                if (res.data.code === "SUCCESS") {
                this.showSnackbar(
                    "#4caf50",
                    "Employee Category Added Successfully..."
                );
                this.onLoad();
                this.close();
                } else if (res.data.code === "NA") {
                this.showSnackbar("#b71c1c", "Employee Category Already Present!!!");
                }

            })
            .catch(error => {
                console.log(error);
            });
        }
    }, 

      isValidated(){
      if(this.editedItem.service_type)
       { 
           return true; 
       }
      else{
            if(!this.editedItem.service_type)
            {
              this.errorMsg.serviceType=true
            }
           
        return false;
      }  
     } 
    },
  }
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size{
  font-size: 20px;
}
.edit-avatar{
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover{
  background-color: #b0bec5;
}
.edit-v-icon{
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover{
  color: white;
}
</style>